import React from 'react';
import {mapStateToProps, mapDispatchToProps} from '../redux/redux'
import {connect} from "react-redux";
import {config, Keyframes} from 'react-spring/renderprops';
import {useSpring, animated} from 'react-spring';
import { ReactComponent as Mouse} from '../animations/Scroll Anim.svg';
import Arrow from '../animations/Arrow.svg';

const delay = (time) => {
    new Promise((resolve, reject) => {
        setTimeout(resolve, time)
    })
}

const Scroll = Keyframes.Spring( async next => {
    while (true) {
        await next({top: "19em", from: {top: "21em"}, config: {mass: 0.6, friction: 40, velocity: 50, tension: 400}})
        await delay(650)
        await next({top: "21em", from: {top: "19em"}, config: config.stiff , reset: true})
        await delay(100)
    }
})


function ScrollAnimationPre(props) {

    const opace = useSpring({opacity: 1, from: {opacity: 0}, config: config.molasses})

    return(
        <div>
            <animated.span style={opace}>
                    <Mouse className="scrollAnimation" style={{transform: "translateX(45.73vw)"}} alt="scroll anim" width="10%"/>
                <Scroll>{style => 
                    <img className="scrollAnimation" style={style} src={Arrow} width="1.5%"/>
                    }
                    </Scroll>
                
            </animated.span>

        </div>
    )
}

let ScrollAnimation = (connect)(mapStateToProps, mapDispatchToProps)(ScrollAnimationPre);
export default ScrollAnimation;